/* ═══════════════════════════════════════════
   § 0. SUBDOMAIN ROUTER — Shape-Shifts the page
   ═══════════════════════════════════════════ */

const hostname = window.location.hostname;
let plotosMode = 'CLIENT_MAP'; // Default
let active_project = '';

// Check for Cloudflare Worker headers (not accessible from JS fetch to self, so use hostname logic)
if (hostname === 'plotos.in' || hostname === 'www.plotos.in') {
  plotosMode = 'LANDING_PAGE';
} else if (hostname === 'studio.plotos.in') {
  plotosMode = 'STUDIO_CRM';
} else if (hostname.endsWith('.plotos.in')) {
  // Extract slug: nakshatra.plotos.in → nakshatra
  active_project = hostname.split('.')[0];
  plotosMode = 'CLIENT_MAP';
} else {
  // Local dev / direct file / custom domain fallback
  const urlParams = new URLSearchParams(window.location.search);
  active_project = urlParams.get('project') || localStorage.getItem('active_project') || 'nakshatra';
}

export { plotosMode, active_project };
